import type { MessageInstance } from "antd/es/message/interface"
import type { HookAPI } from "antd/es/modal/useModal"
import type { TFunction } from "react-i18next"

import { normalizeEmail } from "../form/normalizeEmail.tsx"

interface ConfirmEmailChangeArgs {
  modal: HookAPI
  message: MessageInstance
  t: TFunction
  stored: string | null | undefined
  next: string | null | undefined
}

/** Resolves true when the save may go ahead, and announces a declined change. */
function confirmCustomerEmailChange({
  modal,
  message,
  t,
  stored,
  next
}: ConfirmEmailChangeArgs): Promise<boolean> {
  // Compared normalised, shown as typed.
  const wanted = (next ?? "").trim()
  const current = (stored ?? "").trim()

  if (
    !wanted ||
    !current ||
    normalizeEmail(wanted) === normalizeEmail(current)
  ) {
    return Promise.resolve(true)
  }

  return new Promise((resolve) => {
    modal.confirm({
      centered: true,
      title: t("customerEmailChange.title"),
      content: t("customerEmailChange.body", { email: wanted }),
      okText: t("customerEmailChange.confirm"),
      cancelText: t("customerEmailChange.cancel"),
      onOk: () => resolve(true),
      onCancel: () => {
        message.info(t("customerEmailChange.cancelled"))
        resolve(false)
      }
    })
  })
}

export { confirmCustomerEmailChange }
